<!-- <ion-app>
  <ion-split-pane
    when="sm"
    contentId="menuContent"
    *ngIf="showMenu"
    class="ion-split-pane-content"
  >
    <ion-menu contentId="menuContent"  side="start" menuId="first" type="overlay" >
      <ion-content color="primary">
        <app-vertical-header    [menuItems]="menuItems"></app-vertical-header>
      </ion-content>
    </ion-menu>

  </ion-split-pane>
</ion-app> -->


<app-vertical-header [menuItems]="menuItems"></app-vertical-header>


